import type { MatchReplaceRule } from '../store/proxy-store';
import { mergeMatchReplaceRulesFromServer } from './match-replace-rules-merge';

export type PendingBrowserConfigHydration =
  | { action: 'noop' }
  | { action: 'clear-rules-and-wait' };

export function resolvePendingBrowserConfigHydration({
  isAppSwitch,
}: {
  isAppSwitch: boolean;
}): PendingBrowserConfigHydration {
  if (isAppSwitch) {
    return { action: 'clear-rules-and-wait' };
  }

  return { action: 'noop' };
}

export function resolveMatchReplaceRulesForHydration({
  isAppSwitch,
  localRules,
  serverRules,
  dirtyRuleIds,
}: {
  isAppSwitch: boolean;
  localRules: MatchReplaceRule[];
  serverRules: MatchReplaceRule[];
  dirtyRuleIds: ReadonlySet<string>;
}): { mode: 'replace' | 'merge'; rules: MatchReplaceRule[] } {
  if (isAppSwitch) {
    return {
      mode: 'replace',
      rules: serverRules,
    };
  }

  return {
    mode: 'merge',
    rules: mergeMatchReplaceRulesFromServer({
      localRules,
      serverRules,
      dirtyRuleIds,
    }),
  };
}
